/**
 * Created by ed on 2/10/17.
 */
import React, { Component } from 'react';
import WizardAncestryLevel from './WizardAncestryLevel.js';
//import Implode from '../helpers/HelperTools';

class Wizard extends Component {

    render() {
        let levels = this.props.levels;
        if (levels < 1) levels = 1;
        let rendered_levels = [];

        for (let i = 0, len = levels; i < len; i++) {
            let current = false;
            if (i === this.props.current) current = true;
            rendered_levels.push(
                <WizardAncestryLevel value={i} key={i.toString()} current={current} hasValue={this.props.hasValue} changeToLevel={this.props.changeToLevel} />
            );
        }

        return (
            <ul>{rendered_levels}</ul>
        )
    }
}

export default Wizard;


// WEBPACK FOOTER //
// ./src/components/Wizard.js